export function updateCurrentPath(newPath, newHash, newSearch) {
  return {
    type: 'UPDATE_CURRENT_PATH',
    payload: { name: newPath, hash: newHash, search: newSearch },
  }
}

export function showHireMe() {
  return {
    type: 'WORK FOR EVERLANE',
    payload: 'Know Redux and want to work for Everlane? Email taylor.sullivan@everlane.com',
  }
}

export function showHalfScreenCart(isShowHalfScreenCart) {
  return {
    type: 'SHOW_HALF_SCREEN_CART',
    showHalfScreenCart: isShowHalfScreenCart,
  }
}

export function blockCart() {
  return {
    type: 'BLOCK_CART',
  }
}

export function unblockCart() {
  return {
    type: 'UNBLOCK_CART',
  }
}

export function openCart() {
  return {
    type: 'OPEN_CART',
  }
}

export function closeCart() {
  return {
    type: 'CLOSE_CART',
  }
}

export function enableCart() {
  return {
    type: 'ENABLE_CART',
  }
}

export function openNavigation() {
  return {
    type: 'OPEN_NAVIGATION',
  }
}

export function closeNavigation() {
  return {
    type: 'CLOSE_NAVIGATION',
  }
}

export function startRequest() {
  return {
    type: 'START_REQUEST',
  }
}

export function finishRequest() {
  return {
    type: 'FINISH_REQUEST',
  }
}

export function resetLineItems(newLineItems) {
  return {
    type: 'RESET_LINE_ITEMS',
    payload: newLineItems,
  }
}

// The odd structure of the `meta` field here is to facilitate the eventual use of `redux-segment`
export function fireEvent(eventName, eventPayload) {
  return {
    type: 'FIRE_EVENT',
    meta: {
      analytics: {
        eventType: 'track',
        eventPayload: {
          event: eventName,
          properties: eventPayload,
        },
      },
    },
  }
}

// We shouldn't call this directly, please look at resetUserAndAddresses in
// base/actions/asynchronous.js
export function resetUser(newAttributes) {
  return {
    type: 'RESET_USER',
    payload: newAttributes,
  }
}

export function receiveLineItem(lineItemResponse) {
  return {
    type: 'RECEIVE_LINE_ITEM',
    payload: lineItemResponse,
  }
}

export function receiveOrderPreview(orderPreview) {
  return {
    type: 'RECEIVE_ORDER_PREVIEW',
    payload: orderPreview,
  }
}

export function receiveShippingOptions(shippingOptions) {
  return {
    type: 'RECEIVE_SHIPPING_OPTIONS',
    payload: shippingOptions,
  }
}

// This address should have primary: true
export function receiveAddress(newAddress) {
  return {
    type: 'RECEIVE_ADDRESS',
    payload: newAddress,
  }
}

export function receiveAddresses(newAddresses) {
  return {
    type: 'RECEIVE_ADDRESSES',
    payload: newAddresses,
  }
}

export function receiveCreditCards(newCreditCards) {
  return {
    type: 'RECEIVE_CREDIT_CARDS',
    payload: newCreditCards,
  }
}

export function resetBraintreeToken() {
  return {
    type: 'RESET_BRAINTREE_TOKEN',
  }
}

export function setPaymentMethod(method) {
  return {
    type: 'SET_PAYMENT_METHOD',
    payload: method,
  }
}

export function changeShippingOption(newlySelectedShippingOption) {
  return {
    type: 'CHANGE_SHIPPING_OPTION',
    payload: newlySelectedShippingOption,
  }
}

export function receiveGuestCheckoutEmail(email) {
  return {
    type: 'RECEIVE_CHECKOUT_EMAIL',
    payload: email,
  }
}

// We shouldn't call this directly, please look at resetVisitorAndAddresses in
// base/actions/asynchronous.js
export function resetVisitor(newVisitor) {
  return {
    type: 'RESET_VISITOR',
    payload: newVisitor,
  }
}

export function resetCart(newCart) {
  return {
    type: 'RESET_CART',
    payload: newCart,
  }
}

export function receiveOrder(order) {
  return {
    type: 'RECEIVE_ORDER',
    payload: order,
  }
}

export function setNewQuantityForReturnUnit({ returnAuthorization, returnUnitId, newQuantity }) {
  return {
    type: 'SET_NEW_QUANTITY_FOR_RETURN_UNIT',
    payload: { returnAuthorization, returnUnitId, newQuantity },
  }
}

export function receiveCollection(collection) {
  return {
    type: 'RECEIVE_COLLECTION',
    payload: collection,
  }
}

export function receiveProductPrices(productPrices) {
  return {
    type: 'RECEIVE_PRODUCT_PRICES',
    payload: productPrices,
  }
}

export function receivePDPCollection(collection) {
  return {
    type: 'RECEIVE_PDP_COLLECTION',
    payload: collection,
  }
}

export function setModelSizeSelection(payload) {
  return {
    type: 'SET_MODEL_SIZE_SELECTION',
    payload,
  }
}

export function receiveProducts(products) {
  return {
    type: 'RECEIVE_PRODUCTS',
    payload: products,
  }
}

export function removeAddressesFromSession() {
  return {
    type: 'REMOVE_SESSION_ADDRESSES',
  }
}

export function removeCreditCardsFromSession() {
  return {
    type: 'REMOVE_SESSION_CREDIT_CARDS',
  }
}

export function removeAddress(addressId) {
  return {
    type: 'REMOVE_ADDRESS',
    payload: addressId,
  }
}

export function updateVisitor(newAttributes) {
  return {
    type: 'UPDATE_VISITOR',
    payload: newAttributes,
  }
}

export function updateDeviceFingerprint(fingerprint) {
  return {
    type: 'UPDATE_DEVICE_FINGERPRINT',
    payload: fingerprint,
  }
}

export function receiveSidenavMenus(menus) {
  return {
    type: 'RECEIVE_SIDENAV',
    payload: menus,
  }
}

export function receiveBuilderMenus(menus) {
  return {
    type: 'RECEIVE_BUILDER_MENUS',
    payload: menus,
  }
}

export function receiveBuilderMenusV2(menus) {
  return {
    type: 'RECEIVE_BUILDER_MENUS_V2',
    payload: menus,
  }
}

export function receiveProductUpsell(upsellProductGroups, productUpsellPermalinks) {
  return {
    type: 'RECEIVE_PRODUCT_UPSELL',
    payload: { upsellProductGroups, productUpsellPermalinks },
  }
}

export function receiveModal(modal) {
  return {
    type: 'RECEIVE_MODAL',
    payload: { modal },
  }
}

export function setSelectedVariant(variant, permalink) {
  return {
    type: 'SET_SELECTED_VARIANT',
    payload: { variant, permalink },
  }
}

export function setSelectedVariantSize(variant) {
  return {
    type: 'SET_SELECTED_VARIANT_SIZE',
    payload: { variant },
  }
}

export function setVariantSelectionPrompt(selectionNeeded) {
  return {
    type: 'SET_VARIANT_SELECTION_PROMPT',
    payload: { selectionNeeded },
  }
}

export function setAddToCartErrorMessage(message) {
  return {
    type: 'SET_ADD_TO_CART_ERROR_MESSAGE',
    payload: { message },
  }
}

export function setWaitlistReservation(waitlistItem) {
  return {
    type: 'SET_WAITLIST_RESERVATION',
    payload: waitlistItem,
  }
}

export function setSelectedProduct(product) {
  return {
    type: 'SET_SELECTED_PRODUCT',
    payload: { product },
  }
}

export function setOpenMenu(menuId) {
  return {
    type: 'SET_OPEN_MENU',
    payload: menuId,
  }
}

export function setPurchaseAreaVisible(visible) {
  return {
    type: 'SET_PURCHASE_AREA_ENTERED_OR_LEFT',
    payload: visible,
  }
}

export function setEmailSubscription(subscriptions) {
  return {
    type: 'SET_EMAIL_SUBSCRIPTION',
    payload: subscriptions,
  }
}

export function receiveEmailSubscription(subscriptions) {
  return {
    type: 'RECEIVE_EMAIL_SUBSCRIPTION',
    payload: subscriptions,
  }
}

export function userSetShippingOption() {
  return {
    type: 'USER_SET_SHIPPING_OPTION',
  }
}

export function unsetShippingOption() {
  return {
    type: 'UNSET_SHIPPING_OPTION',
  }
}

export function setFilters(filters) {
  return {
    type: 'SET_FILTERS',
    payload: filters,
  }
}

export function addFilter(filter) {
  return {
    type: 'ADD_FILTER',
    payload: filter,
  }
}

export function clearFilters() {
  return {
    type: 'CLEAR_FILTERS',
  }
}

export function setFiltersQueryParams(params) {
  return {
    type: 'SET_FILTERS_QUERY_PARAMS',
    payload: params,
  }
}

export function receivePage(page) {
  return {
    type: 'RECEIVE_PAGE',
    payload: page,
  }
}

export function setSessionMessage(message, error = false) {
  return {
    type: 'RECEIVE_MESSAGE',
    payload: {
      message,
      error,
    },
  }
}

export function clearSessionMessage() {
  return {
    type: 'CLEAR_MESSAGE',
    payload: {},
  }
}

export function updateShippingPolicy(newShippingPolicy) {
  return {
    type: 'UPDATE_SHIPPING_POLICY',
    payload: newShippingPolicy,
  }
}

export function updateRegions(regions) {
  return {
    type: 'UPDATE_REGIONS',
    payload: regions,
  }
}

export function receiveAppConfig(config) {
  return {
    type: 'RECEIVE_APP_CONFIG',
    payload: config,
  }
}

export function receiveShippingConstants(constants) {
  return {
    type: 'RECEIVE_SHIPPING_CONSTANTS',
    payload: constants,
  }
}

export function receiveInitialSession(session) {
  return {
    type: 'RECEIVE_INITIAL_SESSION',
    payload: session,
  }
}

export function receiveReturnPolicy(returnPolicy) {
  return {
    type: 'RECEIVE_RETURN_POLICY',
    payload: returnPolicy,
  }
}

export function receiveShowingFlyoutCart(bool) {
  return {
    type: 'RECEIVE_SHOWING_FLYOUT_CART',
    payload: bool,
  }
}

export function receiveFactories(factories) {
  return {
    type: 'RECEIVE_FACTORIES',
    payload: factories,
  }
}
